module.exports = __webpack_public_path__ + "static/media/dabajianshanadj.89dd7264.webp";